import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
type DeckNavProps = {
  tone: 'light' | 'dark';
};

/**
 * On-screen previous/next buttons so viewers of the shared link can move
 * through the deck without knowing the keyboard shortcuts. They hand off to
 * the deck's existing keyboard navigation rather than tracking slides here.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function DeckNav({
  tone
}: DeckNavProps) {
  return <>
      <button type="button" onClick={() => goTo('ArrowLeft')} aria-label="Previous slide" className="absolute left-[1.2cqw] top-1/2 z-20 flex h-[3.6cqw] w-[3.6cqw] -translate-y-1/2 items-center justify-center bg-mm-orange text-mm-black transition-colors hover:bg-mm-white focus:outline-none focus-visible:ring-2 focus-visible:ring-mm-white" data-id="element-9" data-mp="1tbrvn544ibjs">
        <ChevronLeft className="h-[2cqw] w-[2cqw]" aria-hidden="true" data-id="element-10" data-mp="cvfbtbfym1gu" />
      </button>
      <button type="button" onClick={() => goTo('ArrowRight')} aria-label="Next slide" className="absolute right-[1.2cqw] top-1/2 z-20 flex h-[3.6cqw] w-[3.6cqw] -translate-y-1/2 items-center justify-center bg-mm-orange text-mm-black transition-colors hover:bg-mm-white focus:outline-none focus-visible:ring-2 focus-visible:ring-mm-white" data-id="element-11" data-mp="7x400v63tgvz">
        <ChevronRight className="h-[2cqw] w-[2cqw]" aria-hidden="true" data-id="element-12" data-mp="1vtlgz3c5aj6b" />
      </button>
    </>;
}
function goTo(key: 'ArrowLeft' | 'ArrowRight') {
  window.dispatchEvent(new KeyboardEvent('keydown', {
    key
  }));
}